<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form
      :inline="true"
      v-if="buttonList != null && buttonList.length > 0"
      :model="filters"
      @submit.native.prevent
      @row-click="selectCurrentRow"
    >
      <el-form-item label="课程名称">
        <el-input v-model="filters.Subject" placeholder="请输入课程名称"></el-input>
      </el-form-item>
      <el-form-item label="授课老师">
        <el-input v-model="filters.Teacher" placeholder="请输入授课老师"></el-input>
      </el-form-item>
      <el-form-item label="学员名称">
        <el-input v-model="filters.MemberName" placeholder="请输入学员名称"></el-input>
      </el-form-item>
     
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <el-button
          :type="
            item.Func &&
            (item.Func.toLowerCase().indexOf('handledel') != -1 ||
              item.Func.toLowerCase().indexOf('stop') != -1)
              ? 'danger'
              : 'primary'
          "
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button> 
      </el-form-item>
    </el-form>
    <!--列表-->
    <!-- <el-button type="primary" v-if="PL_IF" @click="batchPass" :disabled="this.sels.length===0">批量审批</el-button> -->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
    >
      <el-table-column
        prop="Subject"
        label="课程名称"
        width
        sortable
      ></el-table-column>
      <el-table-column
        prop="Teacher"
        label="授课老师"
        width
        sortable
      ></el-table-column>
      <el-table-column
        prop="MemberName"
        label="学员名称"
        width
        sortable
      ></el-table-column>      
      <el-table-column
        prop="CreateTime"
        label="签到日期"
        :formatter="formatDateTime"
        width
        sortable
      ></el-table-column>
      <!-- <el-table-column
        prop="Status"
        label="状态"
        :formatter="formatStatus"
        width
        sortable
      ></el-table-column> -->
     
      <!-- <el-table-column label="操作">
        <template scope="scope">
          <el-link type="primary" @click="handleOpen(scope.row.Id)">
            详情
          </el-link> | 
          <el-link
            type="primary"
            @click="handleEdit(scope.row.Id)"
          >
            编辑
          </el-link>
            <span v-if="scope.row.Type==1?true:false"> | </span> 
          <el-link  v-if="scope.row.Type==1?true:false"
            type="primary"
            @click="handleDetailOpen(scope.row.Id)"
          >
            查看签到码
          </el-link> 
        </template>
      </el-table-column> -->
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <el-dialog
      :title="dialog_title"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :before-close="editForm_close"
      :close-on-click-modal="false"
    >
      <!-- <div style="padding: 20px">
        <el-button type="primary" @click="link_class()">关联课程</el-button>
        <el-button type="primary" @click="link_class_jl()">关联教练</el-button>
      </div> -->
      <el-form
        :model="editForm"
        label-width="180px"
        :rules="editFormRules"
        ref="editForm"
      >
       <el-row>
          <el-col :span="12">
            <el-form-item label="课程名称" prop="Subject">
              <el-input
                :disabled="DETAIS_IF"
                v-model="editForm.Subject"
                auto-complete="off"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程类型" prop="Type">
              <el-select
                v-model="editForm.Type"
                :disabled="DETAIS_IF"
                placeholder="请选择"
                style="width: 100%"
                @change="Type_change"
              >
                <el-option label="线上培训" :value="0"></el-option>
                <el-option label="线下培训" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="状态" prop="Status">
              <el-select
                v-model="editForm.Status"
                :disabled="DETAIS_IF"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="正常" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="PassWord">
              <el-input
                :disabled="DETAIS_IF"
                v-model="editForm.PassWord"
                auto-complete="off"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="课程描述" prop="Reamrk">
              <el-input
                :disabled="DETAIS_IF"
                v-model="editForm.Reamrk"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col> 
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="授课老师" prop="Teacher">
              <el-input
                :disabled="DETAIS_IF"
                v-model="editForm.Teacher"
                auto-complete="off"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="评论区" prop="IsOpenEvaluation">
              <el-select
                v-model="editForm.IsOpenEvaluation"
                :disabled="DETAIS_IF"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="开启" :value="true"></el-option>
                <el-option label="关闭" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="isOnLine">
            <el-form-item label="缩略图">
              <el-upload
                :disabled="DETAIS_IF"
                class="avatar-uploader"
                action="/api/Img/ImgUp"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :headers="token"
              >
                <img
                  v-if="thumbnail_imageUrl"
                  :src="thumbnail_imageUrl"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div style="color: red">
                *建议上传图片宽高比例（16 ：9）
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="isOnLine">
            <el-form-item label="视频">
              <el-upload
                :disabled="DETAIS_IF"
                class="avatar-uploader"
                action="/api/Img/VideoUp"
                :show-file-list="false"
                :on-success="handleLinkAvatarSuccess"
                :headers="token"
              >  <el-button type="primary">点击上传</el-button>
              </el-upload>
              <div style="color: red">
                *请上传视频
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="isOnLine">
          <el-form-item label="视频路径" prop="Link">
              <a :href="editForm.Link">{{ editForm.Link }}</a>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editForm_close">取消</el-button>
        <el-button
          v-if="!DETAIS_IF"
          type="primary"
          @click.native="editSubmit('editForm')"
          :loading="editLoading"
        >
          确认
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="dialog_title"
      :visible.sync="detailFormVisible"
      v-model="detailFormVisible"
      :before-close="detailForm_close"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form
        :model="detailForm"
        label-width="180px"
        ref="detailForm"
      >
       <el-row style="text-align: center;">
          <el-col :span="24">
            <el-image 
              style="width: 200px; height: 200px;"
              :src="QrCode_imageUrl">
            </el-image>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="detailForm_close">取消</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import {
  GetMemberCultivateList,
  ExportToExcelMemberCultivateList,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      fileList: [],
      token: {},
      DETAIS_IF: true,
      READ: true,
      READ_IF: true,
      UPLoad_IF: true,
      UPLoad_IF_Show:false,
      isShowHide:false,
      couponId:0,
      dialog_title: "",
      detailFormVisible: false,
      detailForm: {
      },
      QrCode_imageUrl: "",
      editLoading: false,
      editForm: {
        // ClassDate: "",
        // ClassStartTimeKey: "",
      },
      editFormRules: {
        Subject: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        Type: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        Status: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
      editFormVisible: false,
      editFormVisible_class: false,
      editFormVisible_jl: false,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      PL_IF: true,
      filters: {
        Subject: "",
        Teacher: "",
        MemberName: ""
      },
      users: [],
      users_dialog: [],
      users_dialog_jl: [],
      total: 0,
      total_dialog: 0,
      page: 1,
      page_dialog: 1,
      page_dialog_jl: 1,
      thumbnail_imageUrl: "",
      isOnLine:false,
      listLoading: false,
      sels: [], //列表选中列
      TencentMeetingNumber_if: false,
    };
  },
  methods: {
    ExportMemberCultivate() {
      ExportToExcelMemberCultivateList(this.filters).then((res) => {
        // window.open("https://share.51i.cc" + res.data.msg);
        window.open("https://share.51i.cc" + res.data.msg);
        // window.location.href ="https://share.51i.cc" + res.data.msg;
      });
    },
    handleAvatarSuccess(res, file) {
        if (file.response.success) {
          this.thumbnail_imageUrl = URL.createObjectURL(file.raw);
          this.editForm.Thumbnail = file.response.response;
        } else {
          this.$message({
            message: file.response.msg,
            type: "error",
          });
        }
      },
    handleLinkAvatarSuccess(res, file) {
        if (file.response.success) {
          this.editForm.Link ="https://share.51i.cc/" + file.response.response;
        } else {
          this.$message({
            message: file.response.msg,
            type: "error",
          });
        }
      },
      Type_change(e, num) {
      //选择课程类型，隐藏显示图片和视频上传
      if (e == 1) {
        this.isOnLine=false;
      }
      else {
        this.isOnLine=true;
        }
      },
    link_class() {
      this.GetMemberCultivateList();
      this.page_dialog = 1;
      this.editFormVisible_class = true;
    },
    selsChange: function (value) {
      this.sels = value;
    },
    async editSubmit(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            if (!this.editForm.Thumbnail) {
              this.$message({
                message: "请上传缩略图",
                type: "error",
              });
              return;
            }
            let data;
            if (this.dialog_title == "新增") {
              data = await CurriculumPost(this.editForm);
            } else {
              data = await CurriculumPut(this.editForm);
            }
            if (data.data.success) {
              this.editFormVisible = false;
              this.$message({
                message: data.data.msg,
                type: "success",
              });
              this.getModules_search();
              this.editForm = {};
            }
            else
            {
              this.editFormVisible = false;
              this.$message({
                message: data.data.msg,
                type: "error",
              });
              this.getModules_search();
              this.editForm = {};
            }
          } else {
            return false;
          }
        });
      },
    handleAdd() {
      // this.User_GetClassList_fn();
      // this.ClassInfo_GetClassList_fn();
      this.editFormVisible = true;
      this.dialog_title = "新增";
      this.DETAIS_IF = false;
      this.thumbnail_imageUrl = "";
      this.link_Url="";
    },
    editForm_close() {
      this.editFormVisible = false;
      this.editForm = {};
    },
    async details_CurriculumGet(ids) {
      const { data } = await CurriculumGet({
        id: ids,
      });
      this.editForm = data.response;
      console.log(this.editForm)
      this.editFormVisible = true;
      if (this.editForm.Type == 1) {
        this.isOnLine = false;
      }
      else {
        this.isOnLine = true;
      }
      if (data.response.Thumbnail) {
          this.thumbnail_imageUrl = 'https://share.51i.cc/' + data.response.Thumbnail;
        }
    },
    detailForm_close() {
      this.detailFormVisible = false;
      this.detailForm = {};
    },
    async QrCodeDetails_CurriculumGet(ids) {
      const { data } = await QrCodeCurriculumGet({
        id: ids,
      });
      this.detailForm = data.response;
      if (data.response.QRCodeUrl) {
          this.QrCode_imageUrl = data.response.QRCodeUrl;
          // console.log(data.response.QRCodeUrl)
        }
      this.detailFormVisible = true;
    },
    // 查看二维码
    async handleDetailOpen(ids) {
      this.QrCodeDetails_CurriculumGet(ids);
      this.DETAIS_IF = true;
      this.dialog_title = "签到码";
    },
    // 查看
    async handleOpen(ids) {
      this.details_CurriculumGet(ids);
      this.DETAIS_IF = true;
      this.READ = true;
      this.READ_IF = true;
      // this.editFormVisible = true;
      this.dialog_title = "查看";
    },
    async handleEdit(ids) {
      this.details_CurriculumGet(ids);
      // this.editFormVisible = true;
      this.dialog_title = "编辑";
      this.DETAIS_IF = false;
    },
    selectCurrentRow(val) {
      this.currentRow = val;
      //此处根据选中的券，判断是否符合导入
      let row = this.currentRow;
    },
    callFunc(item) {
      this[item.Func].apply(this, item);
    },

    //日期显示转换
    formatDateTime: function (row, column) {
      let data = row[column.property]
      if (data == null) {
        return null
      }else {
        return util.formatDate.format(new Date(data), "yyyy-MM-dd");
      }
    },
    formatStatus: function (row, column) {
      let data = row[column.property]
      if (data == 1) {
        return "已完成"
      }else if (data == 0){
        return "未完成";
      }else {
        return null
      }
    },
    formatType: function (row, column) {
      let data = row[column.property]
      if (data == 1) {
        return "线下培训"
      }else if (data == 0){
        return "线上培训";
      }else {
        return null
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getModules();
    },
    getModules_search() {
      this.page = 1;
      this.getModules();
    },
    ImportUserTagDetail() {
      this.page = 1;
      this.getModules();
    },
    // handleChange(file)
    // {
    //   //验证文件格式
    //   const isXlS =
    //     file.type ===
    //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    //     file.type === "application/vnd.ms-excel";
    //   if (!isXlS) {
    //     this.$message.error("Please upload files in xls and xlsx formats!");
    //     return;
    //   }
    // },
    handlebefore() {
      const loading = this.$loading({
        lock: true,
        text: "loading......",
      });
    },
    handonerror() {
      // console.log("超时失败");
      const loading = this.$loading({
        lock: true,
        text: "loading......",
      });
      this.$message({
        message: "您的上传已超时，请再次尝试",
        type: "error",
      });
      loading.close();
    },
    handleSuccess(file, fileLis) {
      const loading = this.$loading({
        lock: true,
        text: "loading......",
      });
      if (file.success == true) {
        loading.close();
        this.QUEST_IF = true;
        this.$alert(file.msg, "提示", {
          confirmButtonText: "确定",
        });
      } else if (file.success == false) {
        loading.close();
        this.$alert(file.msg, "提示", {
          confirmButtonText: "确定",
        });
      } else {
        loading.close();
        this.$message({
          message: "您的上传已超时，请再次尝试",
          type: "error",
        });
      }
    },
    //获取用户列表
    getModules() {
      let para = this.filters;
      para.page = this.page;
      this.listLoading = true;
      GetMemberCultivateList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        // this.buttonList.forEach(element => {
        //   if(element.Func == 'setCouponSystemPush')
        //   {
        //      this.isShowHide = true;
        //   }
        // });
      });
    },
    //删除
    handleDel(ids) {
      // console.log(ids);
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          // let para = { id: ids };
          ClassScheduleDelete({
            id: ids,
          }).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules_search();
          });
        })
        .catch(() => {});
    },
     //审核,阻止，驳回保存
     saveMemberSaveAudit(id,status) {
      var msg='';
      if(status==-1)
      {
        msg="确认驳回吗?"
      }else if(status==1)
      {
        msg="确认通过审核吗?"
      }else if(status==2)
      {
        msg="确认阻止吗?"
      }
      this.$confirm(msg, "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          MemberSaveAudit({
            id: id,
            status:status
          }).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules_search();
          });
        })
        .catch(() => {});
    },
   
  },
  mounted() {
    // let roleNames = JSON.parse(localStorage.getItem("roleNames"));
    this.getModules();
    let tokenStr = window.localStorage.Token;
    this.token = {
      Authorization: "Bearer " + tokenStr,
    };
    console.log(this.token);
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 320px !important;
  height: 180px !important;
  display: block;
}
</style>
<style>
.el-button--primary {
  background-color: #409eff !important;
  border-color: #409eff !important;
}
/* 
  .el-link.el-link--primary:hover {
    color: #409eff !important;
  } */

.el-link.el-link {
  color: #409eff !important;
}
.el-link.is-underline:hover:after {
  border-bottom: 1px solid #409eff !important;
}
.el-link.el-link--default:after,
.el-link.el-link--primary.is-underline:hover:after,
.el-link.el-link--primary:after {
  border-color: #409eff !important;
}
.el-pager li.active {
  color: #409eff !important;
}
</style>
